import React, { PureComponent } from 'react'
import Box from '../../../Shared/Box'
import PropTypes from 'prop-types'
// import './style.scss'
import { Col, Container, Row } from '../../../Shared/Grid'
import Input from '../../../Shared/Form/Input'
import CopyToClipboard from '../../../Shared/CopyToClipboard'
import staySafeFlowtifyGiataImage from './../../../../assets/img/tuvsud_staysafe_flowtify_giata.jpg'
import Loader from '../../../Shared/Loader'
import Alert from '../../../Shared/Alert'
import { getFlowtifyByGiataId } from '../../../../api'


class FlowtifyInfo extends PureComponent {

  state = {
    token: '',
    error: null,
    loading: true
  }

  abortController = new AbortController()

  componentDidMount () {
    this.loadToken()
  }

  componentWillUnmount () {
    this.abortController.abort()
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.giataId !== this.props.giataId) {
      this.loadToken()
    }
  }

  loadToken () {
    this.abortController.abort()
    this.abortController = new AbortController()
    this.setState({ loading: true, error: null, token: '' }, async () => {
      try {
        const response = await getFlowtifyByGiataId(this.props.giataId, this.abortController).fetchPromise
        this.setState({ token: response.token, loading: false })
      } catch (e) {
        if (this.abortController.signal.aborted) {
          return
        }
        this.setState({ error: 'Error', loading: false })
      }
    })
  }

  render () {
    return (
      <div className={'page'}>
        <Box>
          {this.state.loading ? <Loader size={32}/> : null}
          {this.state.error ? <Alert type={'danger'}>{this.state.error}</Alert> : null}
          {!this.state.loading && this.state.error === null ?
            <Container fluid gutterWidth={5} className={'flowtify'}>
              <Row>
                <Col xs={12} sm={7} lg={6}>
                  <div>
                    <label htmlFor="token">Your staysafe-hotelcode</label>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center'
                    }}>
                      <div style={{ flex: '1 1' }}><Input disabled={true} onChange={() => {}} value={this.state.token}/></div>
                      <CopyToClipboard size={'medium'} text={this.state.token}/>
                    </div>
                  </div>
                  <div style={{ margin: '20px 0px' }}>
                    <span>
                        Enter your staysafe-hotelcode in the&nbsp;
                      <a href="https://dashboard.flowtify.de" rel="noreferrer noreferrer"
                         target="_blank">Flowtify Web Dashboard</a>
                    </span>
                  </div>
                  <div style={{ margin: '20px 0px' }}>
                    <div style={{ margin: '10px 0px' }}>And get the Flowtify Audit Tool here:</div>
                    <a href="https://apps.apple.com/de/app/flowtify-audit/id1498750911" target="_blank"
                       rel="noopener noreferrer">
                      <img alt={'appstore'} src="https://www.giata.com/wp-content/uploads/appstore-badge.jpg"/>
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.flowtify.audit.rn.android"
                       target="_blank" rel="noopener noreferrer">
                      <img style={{ marginLeft: '15px' }}
                           alt={'google play'}
                           src="https://www.giata.com/wp-content/uploads/googleplay-badge.jpg"/>
                    </a>
                  </div>
                </Col>
                <Col xs={12} sm={5} lg={6}>
                  <img src={staySafeFlowtifyGiataImage}
                       alt={'staySafe'}
                       style={{ width: '270px', display: 'block', margin: '0px auto' }}/>
                </Col>
              </Row>
            </Container>
            : null}
        </Box>
      </div>
    )
  }
}

FlowtifyInfo.propTypes = {
  giataId: PropTypes.number.isRequired
}
export default FlowtifyInfo

